import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-xhr-backend'
import {initReactI18next} from 'react-i18next'

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        whitelist: ['en', 'ru', 'ja', 'ko', 'zh', 'id'],
        fallbackLng: 'en',
        load: 'languageOnly',
        ns: 'landing',
        // debug: true,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },
        detection: {
            order: ['path', 'navigator'],
            lookupFromPathIndex: 0,
            checkWhitelist: true
        }
    })

export default i18n


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/i18n.ts